define(['jquery', 'libs/underscore-min', 'libs/backbone-min', 'libs/ba-tiny-pubsub.min', 'libs/backbone.getnset'], function ($, _, Backbone) {
	'use strict';

	var BlockPageModel = Backbone.Model.extend({

		initialize: function () {
			this.set('initiated', true);
			this._initSubscriptions();
		},


		setters: {
			blocks: function (blocks) {
				var Model = this,
					blockIds = [];

				// Update and add blocks
				_.each(blocks, function (block) {
					var blockAttrKey = 'block_' + block.id;

					if (Model.get(blockAttrKey) === undefined) {
						block.isNew = true;
					}
					Model.set(blockAttrKey, block);
					blockIds.push(block.id);
				});

				// Remove blocks
				if (Model.get('initiated') === true) {
					_.each(Model.get('blockIds'), function (id) {
						if (blockIds.indexOf(id) === -1) {
							Model.unset('block_' + id);
						}
					});
				}
				Model.set('blockIds', blockIds);

				return blocks;
			}
		},


		_initSubscriptions: function () {
			var Model = this;

			$.subscribe('pageChanged', function (event, data) {
				if (data.id && Model.get('id') === data.id) {
					Model.set(data);
				}
			});
		}
	});

	return BlockPageModel;
});


//////////////////
// WEBPACK FOOTER
// ./models/blockpage.model.js
// module id = 4
// module chunks = 0